import _ from 'lodash'

export function focusFirstError(errors, lineItemErrors) {
  const allErrors = []

  const cursors = [errors]

  if (Object.values(lineItemErrors).length > 0) {
    cursors.push(lineItemErrors)
  }

  while (cursors.length > 0) {
    const cursor = cursors.pop()
    if (cursor?.ref) {
      allErrors.push(cursor)
    } else if (cursor) {
      cursors.push(...Object.values(cursor))
    }
  }

  const element = _(allErrors)
    .flatMap(error => [...document.getElementsByName(error.ref.name)])
    .sortBy(
      element => element.offsetTop,
      element => element.offsetLeft
    )
    .filter(element => typeof element.focus === 'function')
    .first()

  if (element) {
    element.scrollIntoView()
    element.focus()
  }
}
